import {_, locale} from "svelte-i18n";
import {writable} from 'svelte/store';


let currentLocale = null;
locale.subscribe((l) => {
        currentLocale = l;
    }
);
_.subscribe((t) => {
    if (currentLocale) {
        const calendarLink = t("calendar_link")
        menuRows.set(
            [
                menuRow1,
                menuRow2(calendarLink)
            ]
        );
    }
});


const menuRow1 = [
    {
        text: "Besuch",
        image: "/images/allgemein/besuch2.jpeg",
        height: "155px",
        routerLink: "/besuch",
        intlName: "visit_title",
        aspectRatio: "1",
        width: "215px"
    },
    {
        text: "Restaurant",
        image: "/images/allgemein/RestaurantMenu.jpeg",
        height: "155px",
        externalLink: "/#/restaurant",
        intlName: "restaurant_title",
        aspectRatio: "1",
        width: "215px"
    }
]

const menuRow2 = (calendarLink) => [
    {
        text: "Shop",
        image: "/images/allgemein/Quer.png",
        height: "93px",
        externalLink: "https://shop.fondationbeyeler.ch/de/index.html",
        intlName: "shop_title",
        maxHeight: "160px"
    },
    {
        text: "Programm",
        image: "/images/allgemein/MondrianHoch.png",
        height: "217px",
        externalLink: calendarLink,
        intlName: "program_title"
    }
]

const rows = [menuRow1, menuRow2("https://www.fondationbeyeler.ch/programm/kalender")];

export const menuRows = writable(rows);
